var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.6996 12L19.648 17.9485C20.1173 18.4178 20.1173 19.1787 19.648 19.648C19.1787 20.1173 18.4178 20.1173 17.9485 19.648L12 13.6996L6.05155 19.648C5.58223 20.1173 4.82131 20.1173 4.35199 19.648C3.88267 19.1787 3.88267 18.4178 4.35199 17.9485L10.3004 12L4.35199 6.05155C3.88267 5.58223 3.88267 4.82131 4.35199 4.35199C4.82131 3.88267 5.58223 3.88267 6.05155 4.35199L12 10.3004L17.9485 4.35199C18.4178 3.88267 19.1787 3.88267 19.648 4.35199C20.1173 4.82131 20.1173 5.58223 19.648 6.05155L13.6996 12Z","fill":"#142470"}));
}

CloseInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
